import { render, staticRenderFns } from "./DynamicComponentViewer.vue?vue&type=template&id=30bbd35e&scoped=true"
import script from "./DynamicComponentViewer.vue?vue&type=script&lang=js"
export * from "./DynamicComponentViewer.vue?vue&type=script&lang=js"
import style0 from "./DynamicComponentViewer.vue?vue&type=style&index=0&id=30bbd35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bbd35e",
  null
  
)

export default component.exports